"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUIController = void 0;
const gs = require("@ivanlog/gs");
const AppControllerBase_1 = require("./AppControllerBase");
const tmpls_1 = require("../com/tmpls");
const CmpModalDialog_1 = require("../com/CmpModalDialog");
class GUIController extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._lockCounter = 0;
        this._body = gs.q('body').first;
        this._layout = new tmpls_1.LayoutMain();
        this._body.prepend(this._layout);
    }
    initAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._layout.ctrls.cmpHeader.initAsync();
        });
    }
    // public setTabs(tabs: gs.WrapperGS) {
    //     this._tabsContainer.html = '';
    //     this._tabsContainer.append(tabs);
    // }
    // public clearTabs() { this._tabsContainer.html = ''; }
    showPage(page) {
        if (this._page)
            this._page.cut();
        this._page = page;
        this._layout.ctrls.pageContainer.append(page);
        // const newTheme = page.getData('theme');
        // if (newTheme)
        // {
        //     const themeEnum = DesignThemeEnum[newTheme];
        //     if (themeEnum) this.setTheme(themeEnum);     
        // }           
        page.show();
    }
    hidePage() {
        if (!this._page)
            return;
        this._page.cut();
        this._page = undefined;
    }
    lock() {
        if (this._lockCounter === 0)
            this._container.disable();
        this._lockCounter++;
    }
    unlock() {
        this._lockCounter--;
        if (this._lockCounter === 0)
            this._container.enable();
    }
    lockAction(action) {
        return __awaiter(this, void 0, void 0, function* () {
            this.app.gui.lock();
            const r = yield action;
            this.app.gui.unlock();
            return r;
        });
    }
    awaitInLockUIAsync(promise) {
        return __awaiter(this, void 0, void 0, function* () {
            this._layout.ctrls.cmpTxLock.show();
            try {
                const result = yield promise;
                this._layout.ctrls.cmpTxLock.hide();
                return result;
            }
            catch (error) {
                this._layout.ctrls.cmpTxLock.hide();
                throw error;
            }
        });
    }
    showDialogOk(message, title) {
        return __awaiter(this, void 0, void 0, function* () {
            return CmpModalDialog_1.CmpModalDialog.DialogOk(message, title).showAndWaitAsync();
        });
    }
}
exports.GUIController = GUIController;
//# sourceMappingURL=GUIController.js.map